module.exports = __webpack_public_path__ + "static/award-download3000-73ef3cac113975303894ace795b0b7c4.png";